var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a271918f2a839b25adf50dbe84c9099c.svg#F';
                    var viewUrl = 'sprites.a271918f2a839b25adf50dbe84c9099c.svg#view-F';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 34 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };